import * as React from 'react';
import type { SVGProps } from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';

import { TI_TEXT_MAIN_PATH_D } from './logoPaths';

interface LogoTITextProps extends SVGProps<SVGSVGElement> {
  currentUserCode?: string;
  watermarkedPathD?: string;
}

const LogoTIText = ({ currentUserCode, watermarkedPathD, ...svgProps }: LogoTITextProps) => {
  // See LogoTIProText for why this is deferred to after hydration.
  const hydrated = useServerSideRendering();
  const mainPathD = hydrated && watermarkedPathD ? watermarkedPathD : TI_TEXT_MAIN_PATH_D;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1270 132" {...svgProps}>
      <path d={`${mainPathD} ${currentUserCode || ''}`} fill="currentColor" />
    </svg>
  );
};
export default LogoTIText;
